import { Fragment, useContext, useEffect, useRef } from 'react'
import { SocketContext } from '../../context/socket'
import { Link } from 'react-router-dom'
import { appGetAllDashboard } from '../../store/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import { appPendingMembership } from '../../store/sanstha'

function Dashboard() {
	const socket = useContext(SocketContext)
	const dispatch = useDispatch()
	const dashboard = useSelector(state => state?.dashboardReducer.dashboard)

	useEffect(() => {
		socket.connect()
		dispatch(appGetAllDashboard())
	}, [])

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading">
					<div className="d-flex align-items-center">
						<div className="mr-auto">
							<div className="">Dashboard</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row m-3">
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-warning-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Sanstha</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-building fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-4">
									<Link to="/user" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.userCount || 0}</div>
										<div className="small h5">Members</div>
									</Link>
								</div>
								{/* 
								<div className="col-4">
									<Link to="/sanstha" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.sansthaActivating || 0}
										</div>
										<div className="small h5">To be activated</div>
									</Link>
								</div> */}
								{/* 
								<div className="col-4">
									<Link to="/sanstha" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.sansthaVerifying || 0}
										</div>
										<div className="small h5">To be verified</div>
									</Link>
								</div> */}
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<Link to="/sponsor" style={{ textDecoration: 'none' }}>
						<div className="dashboard-card bg-inverse-light h-100" style={{ minHeight: '160px' }}>
							<div className="card-body h-100 d-flex flex-column justify-content-between">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										<div className="h2 mb-0">{dashboard?.sponsorCount || 0}</div>
										<div className="text-uppercase font-weight-bold">Sponsors</div>
										<span className="text-white">Supporting partners</span>
									</div>
									<div className="icon-wrapper">
										<em className="icon-badge fa-2x"></em>
									</div>
								</div>
							</div>
						</div>
					</Link>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<Link to="/payment-history" style={{ textDecoration: 'none' }}>
						<div className="dashboard-card bg-warning-light h-100" style={{ minHeight: '160px' }}>
							<div className="card-body h-100 d-flex flex-column justify-content-between">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										<div className="h2 mb-0">₹{dashboard?.totalFund || 0}</div>
										<div className="text-uppercase font-weight-bold">Total Fund</div>
										<span className="text-white">Total Fund</span>
									</div>
									<div className="icon-wrapper">
										<em className="icon-badge fa-2x"></em>
									</div>
								</div>
							</div>
						</div>
					</Link>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-purple h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Events</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-calendar-alt fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-4">
									<Link to="/event" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.event || 0}</div>
										<div className="small h5">Events</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/event-booking"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.eventBookingCount || 0}
										</div>
										<div className="small h5">Event Bookings</div>
									</Link>
								</div>

								<div className="col-4">
									<Link to="/boli-booking" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.boliBookingcount || 0}
										</div>
										<div className="small h5">Boli Booking</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row m-3">
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-info-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Posts</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-edit fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link to="/post" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.post || 0}</div>
										<div className="small h5">Total Posts</div>
									</Link>
								</div>

								<div className="col-6">
									<Link to="/post" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.postapprovalCountNumber || 0}
										</div>
										<div className="small h5">Pending Approval</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-green-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Social Project</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-project-diagram fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link
										to="/social-project"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">{dashboard?.socialproject || 0}</div>
										<div className="small h5">Projects</div>
									</Link>
								</div>

								<div className="col-6">
									<Link
										to="/socialproject-donation"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.socialprojectbooking || 0}
										</div>
										<div className="small h5">Bookings</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-primary-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Facility</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-building fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link to="/facility" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.facilityCount || 0}</div>
										<div className="small h5">Facilities</div>
									</Link>
								</div>

								<div className="col-6">
									<Link
										to="/facility-booking"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.facilityBooking || 0}
										</div>
										<div className="small h5">Bookings</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-pink-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Contribution</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-hand-holding-heart fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link to="/contribution" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.contribution || 0}</div>
										<div className="small h5">Total Contribution</div>
									</Link>
								</div>

								<div className="col-6">
									<Link to="/requsteduser" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.usersWaiting || 0}</div>
										<div className="small h5">Membership Approval</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row m-3">
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<Link to="/help" style={{ textDecoration: 'none' }}>
						<div className="dashboard-card bg-success h-100" style={{ minHeight: '160px' }}>
							<div className="card-body h-100 d-flex flex-column justify-content-between">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										<div className="h2 mb-0">{dashboard?.helpdesk || 0}</div>
										<div className="text-uppercase font-weight-bold">Help Desk</div>
										<span className="text-white">Help Desk</span>
									</div>
									<div className="icon-wrapper">
										<em className="fas fa-calendar-check fa-2x"></em>
									</div>
								</div>
							</div>
						</div>
					</Link>
				</div>
			</div>
		</>
	)
}

export default Dashboard
